<script>
const name = 'ttam-vnode-renderer';
export default {
  name,
  props: {
    vNode: {
      validator: value => ['object', 'string'].includes(typeof value),
      default: null,
    },
  },
  render() {
    if (typeof this.vNode === 'object') return this.vNode;

    return <span>{this.vNode}</span>;
  },
};
</script>
